<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Vehicles" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#vehicleAdd">Add Vehicle</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Vehicle No</th>
                                            <th>Contact</th>
                                            <th>Driver</th>
                                            <th>Vehicle Details</th>
                                            <th>Booking info</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in vehicles" :key="item.id" >
                                            <td>{{item.vehicle_no}}</td>
                                            <td>{{item.contact}}</td>
                                            <td>{{item.driver_name}}</td>
                                            <td>{{item.vehicle_details}}</td>
                                            <td>
                                                <template v-if="!item.latest_checkout_datetime && !item.latest_checkin_datetime && isToday(item.latest_schedule_datetime)">
                                                    <span style="color: rgb(206, 206, 5);">
                                                    Schedule: {{ item.latest_schedule_datetime }}
                                                    </span>
                                                </template>
                                                <template v-else-if="item.latest_checkout_datetime &&  !item.latest_checkin_datetime">
                                                   <!-- schedule: {{ item.latest_schedule_datetime }} -->
                                                   <span style="color: lightcoral;">
                                                    Booked: {{ item.latest_checkout_datetime }}
                                                  </span>
                                                </template>
                                                <template v-else-if="!latest_schedule_datetime && !latest_checkout_datetime">
                                                    <span style="color: lightgreen;">
                                                    Available 
                                                    </span>
                                                  </template>
                                                <!-- <template v-else>
                                                  {{ item.latest_schedule_datetime }} {{ item.latest_checkout_datetime }} {{ item.latest_checkin_datetime }}
                                                </template> -->
                                              </td>                                              
                                           
                                            <td>
                                                <ul class="action">
                                                    <li class="View" @click="view_vehicle(item.id)"><i class="icon-list"></i></li>&nbsp;
                                                    <li class="edit" @click="edit_vehicle(item)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_vehicle(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
<!-- footer   start-->


<!-- start--------------------------------------------------------------------------------------------------------------------------->

<div v-if="showEditModal" class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Today Booking's</h5>
          <button type="button" class="close" @click="showEditModal = false" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="card-body badge-spacing">
                <div class="table-responsive custom-scrollbar">
                    <table class="table display" id="basic-1">
                        <thead>
                            <tr>
                                <th>SR</th>
                                <th>Vehicle Name</th>
                                <th>Source</th>
                                <th>destination</th>
                                <th>Check Out</th>
                                <th>Check In</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(item ,index)  in vehicles_info" :key="item.id" >
                                <td>{{index+1}}</td>
                                <td>{{item.vehicle_name}}</td>
                                <td>{{item.source}}</td>
                                <td>{{item.destination}}</td>
                                <td>{{item.schedule_checkout_date}} / {{item.schedule_checkout_time}} </td>
                                <td>{{item.schedule_checkin_date}} / {{item.schedule_checkin_time}} </td>
                              
                            
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-primary">Save changes</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
        </div>
      </div>
    </div>
  </div>












<!-- end----------------------------------------------------------------------------------------------------------------------------->















    <ModalsPart v-if="!['login'].includes($route.name)"  @getVehicleData="updateVehicleData" :vehicle="vehicle"/>
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";


const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Vehicles', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
            vehicles: [],
            vehicle: {},
            vehicles_info:[],
            showEditModal: false, 
        }
    },
    methods: { 
        isToday(latest_schedule_datetime) {
            if(latest_schedule_datetime){
             
                const dateOnly = latest_schedule_datetime.split(' ')[0];
                const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
                return dateOnly === today;
            }else 
            return false;
            },
        updateVehicleData(value) {
            this.vehicles = value;
        },
        getBasics() {
            var self = this;
            axios.post('getVehicles').then(function (response) {
                self.vehicles = response.data.vehicles; 
                window.scrollTo(0, 0);
            });
        },
        edit_vehicle(item)
        {
            var self = this;
            self.vehicle = item; 
            $("#vehicleAdd").modal("toggle");
        },
        remove_vehicle(id) {
            var self = this;
            axios.post('removeVehicle', {vehicle_id:id}).then(function (response) {
                self.vehicles = response.data.vehicles; 
                window.scrollTo(0, 0);
            });
        },

        view_vehicle(id) {
            var self = this;
            axios.post('getbookinginfo',{id:id}).then(function (response) {
                self.vehicles = response.data.vehicles; 
                self.vehicles_info = response.data.vehicles_info;
                self.showEditModal=true,
                window.scrollTo(0, 0);
            });
        },


       
    }
}
</script>
